// The launcher runs workspace-scoped queries, so keep the widget off every
// route that has no session.
export const WIDGET_DISABLED_ROUTES = [
	"/login",
	"/logout",
	"/auth-error",
	"/setup-workspace",
	"/unsubscribe",
	"/hubspot-feedback",
]

export function isWidgetDisabledRoute(pathname: string): boolean {
	return WIDGET_DISABLED_ROUTES.some((route) => pathname.startsWith(route))
}
